export default __webpack_public_path__ + "static/media/fundo4.ac88e7a5.jpg";